import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { chinaContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import Web3 from "web3";

const CuurentRound = () => {
  const [balance, setBalance] = useState(null);
  const { account } = useWeb3React();
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);
  const tokenAddress = Environment.presaleContract;
  const contract = chinaContract(tokenAddress, web3);

  const cuurentRound = useCallback(async () => {
    try {
      const buy = await contract.methods.getRoundCount().call();
      return buy;
    } catch (error) {
      throw error;
    }
  }, [contract, account, web3]);
  return { cuurentRound: cuurentRound };
};
export default CuurentRound;
